/**
 * Boxes shared by the `/baskets` list and its skeleton, so the two cannot drift.
 *
 * The grid is one card across on a phone, two from `@md` and three from `@3xl` of the main column,
 * the mock's `bka-grid`, 16 apart.
 */
export const BASKET_GRID = 'grid grid-cols-1 gap-4 @md:grid-cols-2 @3xl:grid-cols-3'

/** The search field: the full row on a phone, the mock's 260 (on the grid, 256) from `@md`. */
export const BASKET_SEARCH = 'w-full @md:w-64'
